<template>

<v-dialog v-model="dialog" width="90vw">
  <v-card>
    <p class=".title ma-2">Ledger mutations - Guest: {{hklrHkgm.klnt_code}} {{hklrHkgm.klnt_naam}}</p>
    <v-form ref="showHklrHkgm">
       

       <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Deb</span></td>
                            <td align="right"><span class="10px font-weight-light">Cred</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>  
                        </thead>
                        

                        <tbody v-for="(hklrRecord,k1) in hklrHkgm.hklr" :key="k1">
                          <tr>
                            <td>{{hklrRecord.hklr_dt}}</td>
                            <td>{{hklrRecord.fctitaal_oms}}</td>
                            <td></td>
                            <td></td>
                            <td align="right">{{hklrRecord.hklr_line }}</td>
                            <td align="right">{{hklrRecord.hklr_payment }}</td>
                          </tr>
                          <template v-for="(hkrdRecord,k2) in hklrRecord.hkrd">
                            <tr :key="`hkrd-${k1}-${k2}`">
                              <td></td>
                              <td><span class="mx-3">{{hkrdRecord.fcti_oms}}</span></td>
                              <td></td>
                              <td></td>
                              <td align="center">{{hkrdRecord.hkrd_bedrag}}</td>
                              <td></td>
                            </tr>
                            <tr v-for="(hkgmRecord,k3) in hkrdRecord.hkgm" :key="`hkgm-${k1}-${k2}-${k3}`">
                              <td><span class="mx-2">{{hkgmRecord.hkgm_datum}}</span></td>
                              <td><span class="mx-6">{{hkgmRecord.gbrk_nr}} - {{hkgmRecord.gbrk_oms}}</span></td>
                              <td align="right">{{hkgmRecord.hkgm_deb}}</td>
                              <td align="right">{{hkgmRecord.hkgm_cred}}</td>
                              <td></td>
                              <td></td>
                            </tr>
                          </template>
                        </tbody>  

                    </template>  
                  </v-simple-table>
       

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      hklrHkgm: {}
    }
  },
  methods: {
    open(huov_encrid, hkgm_boek_verblijf) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.$axios
        .post("ares/json/ares/huov/hklr/hkgm/getHklrHkgm.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHklrHkgm"
          },
          getHklrHkgm: {
            huov_encrid: huov_encrid,
            hkgm_boek_verblijf: hkgm_boek_verblijf
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hklrHkgm = res.data.getHklrHkgm;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

